import React from "react";
import AppId from "../../components/admin/App-id";

const AppIdPage = () => {
  return (
    <div>
     <AppId />
    </div>
  );
};

export default AppIdPage;
